import styled from 'styled-components';
import TIImageLeft from '../../assets/TIImageLeft.png';
import TIImageRigth from '../../assets/TIImageRight.png';
import { Paragraph } from '../../../Paragraph/Paragraph';

interface TIProps {
  mainProductPriceWithoutEHIC?: number;
  mainProductPriceWithEHIC?: number;
}

const CoveragePriceCircle: React.FC<TIProps> = ({
  mainProductPriceWithoutEHIC,
  mainProductPriceWithEHIC
}) => {
  const option1 = 'Option 1:';
  const option2 = 'Option 2:';
  const textOption1 = 'if you have the EHIC*';
  const textOption2 = "if you don't have the EHIC*";
  const coveragePrice = mainProductPriceWithoutEHIC;
  const coveragePrice2 = mainProductPriceWithEHIC;
  const coveragePriceCircle = `<strong>For only <br/><span>${coveragePrice2}€</span></strong><br/> per month`;
  const coveragePriceCircle2 = `<strong>For only <br/><span>${coveragePrice}€</span></strong><br/> per month`;

  return (
    <CoveragesPriceWrapper>
      <ImageLeft />
      <CircleWrapper>
        <OptionWrapper>
          <ParagraphBig text={option1} />
          <ParagraphAlt text={textOption1} />
          <CoveragePrice>
            <ParagraphPrice text={coveragePriceCircle} />
          </CoveragePrice>
        </OptionWrapper>
        <OptionWrapper>
          <ParagraphBig text={option2} />
          <ParagraphAlt text={textOption2} />
          <CoveragePrice2>
            <ParagraphPrice text={coveragePriceCircle2} />
          </CoveragePrice2>
        </OptionWrapper>
      </CircleWrapper>
      <ImageRight />
    </CoveragesPriceWrapper>
  );
};

export default CoveragePriceCircle;

const CoveragePrice = styled.div`
  background-color: #ffe177;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    width: 208px;
    height: 208px;
  }
  @media (min-width: 1024px) {
    width: 250px;
    height: 250px;
  }
`;

const CircleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  @media (min-width: 768px) {
    gap: 20px;
  }
`;

const CoveragePrice2 = styled(CoveragePrice)`
  background-color: #a8e8d3;
`;

const ImageLeft = styled.div`
  background-image: url(${TIImageLeft});
  background-size: cover;
  background-position: center;
  width: 53.1px;
  height: 138.6px;

  @media (min-width: 768px) {
    width: 80px;
    height: 196px;
  }
  @media (min-width: 1024px) {
    width: 97px;
    height: 236px;
  }
`;

const ImageRight = styled.div`
  background-image: url(${TIImageRigth});
  background-size: cover;
  background-position: center;
  width: 73.8px;
  height: 139.5px;

  @media (min-width: 768px) {
    width: 97px;
    height: 171px;
  }
  @media (min-width: 1024px) {
    width: 117px;
    height: 200px;
  }
`;

const ParagraphPrice = styled(Paragraph)`
  font-size: 15px;

  @media (min-width: 768px) {
    font-size: 30px;
  }

  @media (min-width: 1024px) {
    font-size: 35px;
  }
`;

const CoveragesPriceWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  padding: 45px 0 14px 0;

  @media (min-width: 768px) {
    padding: 80px 0 18px 0;
  }
  @media (min-width: 1024px) {
    padding: 72px 0 20px 0;
  }
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ParagraphBig = styled(Paragraph)`
  font-size: 20px;
  padding: 0;
  margin: 0;
  font-weight: 700;

  @media (min-width: 768px) {
    font-size: 34px;
  }
`;

const ParagraphAlt = styled(Paragraph)`
  font-size: 14px;
  padding: 0;
  margin: 5px 0 10px 0;
  min-height: 34px;

  @media (min-width: 768px) {
    font-size: 16px;
    margin: 0 0 10px 0;
  }
`;
